import clsx from 'clsx';
import React from 'react';
import { Icon } from 'ui';

import './PracticeMoreMenu.scss';
import usePracticeMoreMenu from './usePracticeMoreMenu';

/**
 * PracticeMoreMenu - "Practicas más" trigger with a 2-option dropdown:
 * generate automatically, or choose what to practice (TANAI-1869).
 */

type PracticeMoreMenuProps = {
  isDisabled?: boolean;
  onChooseWhatToPractice: () => void;
  onGenerateAutomatically: () => void;
};

function PracticeMoreMenu({ isDisabled = false, onChooseWhatToPractice, onGenerateAutomatically }: PracticeMoreMenuProps): JSX.Element {
  const { containerRef, handleChooseWhatToPractice, handleGenerateAutomatically, isOpen, t, toggleMenu } = usePracticeMoreMenu({
    onChooseWhatToPractice,
    onGenerateAutomatically,
  });

  return (
    <div className="practice-more-menu" ref={containerRef}>
      <button
        aria-expanded={isOpen}
        aria-haspopup="true"
        className={clsx('practice-more-menu__trigger', { 'practice-more-menu__trigger--open': isOpen })}
        disabled={isDisabled}
        onClick={toggleMenu}
        type="button"
      >
        <span className="practice-more-menu__trigger-text">{t('practice_more')}</span>
        <span className="practice-more-menu__trigger-icon">
          <Icon name={isOpen ? 'chevron-up' : 'chevron-down'} size="lg" />
        </span>
      </button>

      {isOpen && (
        <ul className="practice-more-menu__options">
          <li className="practice-more-menu__option">
            <button className="practice-more-menu__option-button" onClick={handleChooseWhatToPractice} type="button">
              {t('practice_more_choose_what')}
            </button>
          </li>
          <li className="practice-more-menu__option">
            <button className="practice-more-menu__option-button" onClick={handleGenerateAutomatically} type="button">
              {t('practice_more_generate_automatically')}
            </button>
          </li>
        </ul>
      )}
    </div>
  );
}

export default PracticeMoreMenu;
